<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box" v-if="ay_std_div_list != null">
            <v-toolbar class="toolbar no-display" flat dense>
                <v-toolbar-title>
                    <strong> Marks Book </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense class="no-display">
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object
                        :items="ay_std_div_list" item-text="ay" label="Select Academic Year" outlined @change="getStd()"
                        persistent-hint hint="Please select academic year" />
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete dense required outlined rounded color="#0F2027" v-model="sem" :items="semester_list"
                        item-text="sem" return-object label="Semester" persistent-hint hint="Please select semester" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="std_div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_std_data" return-object
                        :items="std_div_list" item-text="std" label="Standard" outlined @change="
                            getDiv();
                        " persistent-hint hint="Please select standard" @click="putnull" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="div" item-value="div_off_id"
                        :items="div_list" item-text="div_name" label="Division" outlined persistent-hint
                        hint="Please select division" />
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="status" :items="status_list"
                        item-text="name" return-object label="Status" outlined persistent-hint hint="Select Status" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="sel_ay_data && sel_std_data && div && status
                    ">
                    <v-btn class="mt-6 button" @click="getreport()" :loading="fetch_loader">Fetch</v-btn>
                </v-col>
            </v-row>
            <v-col cols="6" sm="2" md="2">
                <v-btn class="ma-2 no-display " rounded color="success" outlined
                    v-if="learner_course_marks_list != '' && list != '' "
                    @click="fnExcelReport('my-table-id', 'AssessmentDetailedReport')" :loading="loader"><v-icon
                        color="success">mdi-export</v-icon>Export</v-btn>
            </v-col>

            <div id="my-table-id">
                <span v-if="learner_course_marks_list != '' && list != '' ">
                    <v-simple-table fixed-header dense class="elevation-1">
                        <tbody>
                            <tr>
                                <th class="">
                                    <center>Sr. No.</center>
                                </th>
                                <th class="">
                                    <center>Roll No.</center>
                                </th>
                                <th class="">
                                    <center>Registration No.</center>
                                </th>
                                <th class="">
                                    <center>Name</center>
                                </th>
                                <th class="" v-for="(header, index) in list" :key="index">
                                    <center>{{ header.coff_name }}</center>
                                </th>
                                <th>Total</th>
                                <th>Percentage</th>
                            </tr>
                            <tr v-for="(s, index1) in learner_course_marks_list" :key="index1">
                                <td>{{ index1 + 1 }}</td>
                                <td>{{ s.rollno }}</td>
                                <td>{{ s.registration_number }}</td>
                                <td>{{ s.name }}</td>
                                <td v-for="(header, index) in s.comp_marks" :key="index">
                                    <center>{{ header }}</center>
                                </td>
                                <td>{{ s.total }}</td>
                                <td>{{ s.percentage }}</td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </span>
            </div>
        </v-card>
    </div>
</template>
<script>
import axios from "axios";
import jsPDF from "jspdf";
import "jspdf-autotable";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {
    components: {
        Breadcrumbs,
    },

    data() {
        return {
            overlay: false,
            selected: [],
            snackbar: false,
            // extraBreadcrumbItems: [


            // ],
            // breadcrumbClass: "breadcrumb-style1",
            course_list: [],
            crs_id: null,
            search: "",
            crs_list: [],
            snackbar_msg: "",
            color: "",
            snackbar: false,
            ay_std_div_list: null,
            sel_ay_data: null,
            std_div_list: null,
            sel_std_data: null,
            div_list: null,
            div: null,
            semester_list: null,
            sem: null,
            fetch_loader: false,
            assessment_detail_list: [],
            assessment_detail: null,
            standard: null,
            division: null,
            course: null,
            ass_Scheme: null,
            academicyear: null,
            ass_detail_list: null,
            learner_course_marks_list: [],
            inst_name: null,
            atotal: null,
            ass_converted_total: null,
            show: false,
            org_basic_data: [],
            default_value: null,
            list: [],
            ass_list:[],
            ass_size:null,
            status_list: [
                { name: "Active", id: "0" },
                { name: "Temporary Inactive", id: "1" },
                { name: "Permanent Inactive", id: "2" },
            ],
            status: null,
            role:null,
        };
    },

    methods: {
        fnExcelReport(id, name) {
            var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
            tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
            tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
            tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
            tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
            tab_text = tab_text + "<table border='1px'>";
            var exportTable = $("#" + id).clone();
            exportTable.find("input").each(function (index, elem) {
                $(elem).remove();
            });
            tab_text = tab_text + exportTable.html();
            tab_text = tab_text + "</table></body></html>";
            var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

            //Save the file
            // var blob = new Blob([tab_text], {
            //     type: "application/vnd.ms-excel;charset=utf-8",
            // });
            // window.saveAs(blob, fileName);
            const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const filename = name + '.xls';

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                // For IE
                window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
                // For modern browsers
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                a.click();
                window.URL.revokeObjectURL(url);
            }
        },

        myfunction() {
            for (var i = 0; i < this.learner_course_marks_list.length; i++) {
                // var formattter = this.learner_course_marks_list[i].converted_marks.toFixed(2)
                var formattter = Math.round(this.learner_course_marks_list[i].converted_marks);
                //  alert(formattter)
                //this.learner_course_marks_list[i].converted_marks = formattter
                //return
            }
        },
        putnull3() {
            this.show = false;
        },
        print() {
            this.$store.state.drawer = false;
            let that = this;
            window.onafterprint = function () {
                that.$store.state.drawer = true;
            };
            setTimeout(function () {
                window.print();
            }, 100);
        },
        onerror(error) {
            let msg = "";
            if (error.response) {
                msg = "Something went wrong.";
            } else if (error.request) {
                msg = "Please Select Proper Data.";
            } else {
                msg = "Un-expected error.";
            }
            this.showSnackbar("error", msg);
        },
        putnull() {
            this.crs_list = [];
            this.crs_id = null;
        },
        async getreport() {
            this.role = localStorage.getItem("para_role");
            const data = {
                ay: this.sel_ay_data.ay_id,
                standard: this.sel_std_data.std_id,
                sem: this.sem.id,
                div: this.div,
                status: this.status.id,
                role:this.role
            };
            this.fetch_loader = true;
            try {
                const res = await axios.post("/WWSExamination/getAnnualMarkBook", data);
                if (res.data.flag == "YES") {
                    this.learner_course_marks_list = res.data.learner_course_marks_list
                    this.course_list = res.data.course_list
                    this.ass_list = res.data.ass_list
                    this.ass_size = res.data.ass_size
                    this.list = res.data.list
                    if(this.course_list==''){
                        this.showSnackbar("error", "No Data Found");
                    }
                }
                else {
                    sessionStorage.setItem("error-trace", res.data.error_trace);
                }
                this.fetch_loader = false;
            } catch (err) {
                console.log("err", err);
                this.onerror(err);
                this.overlay = false;
            } finally {
                this.fetch_loader = false;
            }
        },
        getStd() {
            this.std_div_list = null;
            this.sel_std_data = null;
            this.div_list = null;
            this.div = null;
            this.std_div_list = this.sel_ay_data.std_list;
        },
        getDiv() {
            // this.div_list = ["All"];
            // this.div = "All";
            this.div_list = this.sel_std_data.div_list;
            // this.div_list.unshift("All");
            //this.div = this.div_list[0];
            if (this.div_list.length == 0) {
                alert("No division found!!!");
                this.div_list = null;
            }
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        onload() {
            axios
                .post("/commonAPI/get_ay_std_div")
                .then((res) => {
                    this.ay_std_div_list = res.data.data;
                    //this.sel_ay_data = this.ay_std_div_list[0];
                    this.semester_list = res.data.semester_list_wws;
                    this.sem = this.semester_list[2];
                    this.assessment_detail_list = ["All"];
                    this.assessment_detail = "All";
                    this.assessment_detail_list = res.data.assessment_detail_list;
                    this.assessment_detail_list.unshift("All");
                    this.assessment_detail = this.assessment_detail_list[0];
                    this.status_list = res.data.status_list;
                    this.status = this.status_list[0];

                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                })
                .finally(() => { });
        },
    },
    mounted() {
        this.onload();


    },
};
</script>
<style scoped>
tr,
td,
th {
    border: 1px solid #ccc;
    text-align: center;
    font-size: small;
}

tr,
tbody {
    border-bottom: 1px solid #ccc;
    border: 1px solid #ccc;
    font-size: small;
}

td {
    margin: 0.3rem !important;
    padding: 0.4rem !important;
    font-size: small;
}

@media (min-width: 320px) {

    td,
    th {
        display: table-cell !important;
        font-size: small;
    }

    td+td,
    th+th {
        width: auto;
        font-size: small;
    }
}

v-simple-table {
    white-space: nowrap !important;
    text-align: center;
    font-size: small;
}

.radiospace {
    margin: 1rem !important;
    padding: 0%;
}

.btn-css {
    outline: 0 !important;
    outline-offset: 0 !important;
    background-image: none !important;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    background-color: #fff !important;
    text-decoration: underline;
    color: #0f2027 !important;
    text-align: left;
}

.btn-css:hover {
    outline: 0 !important;
    outline-offset: 0 !important;
    background-image: none !important;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    background-color: #ffff !important;
    color: #0f2027 !important;
    text-decoration: underline;
    text-align: left;
}

.t-row {
    padding: 1rem i !important;
}

.mytable /deep/ thead th {
    background: #0f2027 !important;
    /* fallback for old browsers */
    background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important;
    /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important;
    /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    background-color: #0f2027 !important;
    color: white !important;
    font-weight: bold !important;
    white-space: nowrap !important;
    text-align: center;
}

.delete-avatar {
    transition: 0.3s;
    border: 1px solid red;
    margin: 0.2rem !important;
}

.delete-avatar:hover {
    background-color: transparent;
}

.delete-v-icon {
    padding-left: 8px;
    padding-top: 1px;
    font-size: 15px;
}

.delete-v-icon:hover {
    color: white;
}

.v-dialogss {
    bottom: 880;
    right: 0;
}

@media print {

    header,
    footer,
    nav,
    date {
        display: none !important;
    }

    table,
    td,
    tr {
        break-inside: avoid-page;
    }

    /*  img {
            width: 100% !important;
        }*/
    body,
    tr,
    th,
    td {
        font-size: 14pt !important;
        font-weight: bold !important;
    }

    .no-display,
    .v-input__control,
    input[type="button"],
    input[type="submit"],
    input[type="reset"],
    #v-card {
        display: none !important;
    }

    v-card {
        border: none !important;
    }

    @page {
        size: A4;
        margin-top: none;
        padding-top: none;
        /*size: 15.5in 15.5in;*/
        size: 16in 20in;
    }

    table,
    td,
    tr,
    th {
        text-align: center !important;
        margin-top: none;
        padding: none !important;
        font-weight: bold !important;
        border-bottom: 1px solid black;
        border: 1px solid black;
    }

    .table-data {
        height: 100% !important;
        overflow-x: hidden;
        overflow-y: hidden !important;
    }

}

.trust-logo {
    width: 86%;
}

.schl-logo {
    width: 86%;
}
</style>

